import React from 'react';
import { useCurrentUser } from '@cp/entities/currentUser';
import { UserType } from '@cp/entities/user';
import { ClientSelection } from 'src/entities/client';
import { AuthFeature } from './types';
import { useAuth } from './useAuth';

export const withAuthInterceptor =
  <T extends (...args: never[]) => any>(predicate: () => boolean, useCase: AuthFeature, decoratedFn: T, parameters?: ClientSelection) =>
  (...args: Parameters<T>): Promise<ReturnType<T>> =>
    predicate()
      ? useCase(parameters).then((result) => result.match({ ok: () => Promise.resolve(decoratedFn(...args)), err: Promise.reject }))
      : Promise.resolve().then(() => decoratedFn(...args));

/**
 * Возвращает функцию-декоратор, которая запускает процесс логина перед выполнением оригинальной функции
 */
export const useAuthInterceptor = () => {
  const currentUser = useCurrentUser();
  const useCase = useAuth();

  return React.useCallback(
    <T extends (...args: never[]) => any>(fn: T, parameters?: ClientSelection) =>
      withAuthInterceptor(() => currentUser.type === UserType.Guest, useCase, fn, parameters),
    [currentUser, useCase],
  );
};
